import { render, staticRenderFns } from "./DetailPermohonan.vue?vue&type=template&id=00ce798b&"
import script from "./DetailPermohonan.vue?vue&type=script&lang=js&"
export * from "./DetailPermohonan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports